import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from './pages/NotFound'

// ========================= Users Item =========================
import CalculateProfit from './pages/exchange/CalculateProfit'
import EnableTradingSetting from './pages/exchange/EnableTradingSetting'
import EnableWithdrawalSetting from './pages/exchange/EnableWithdrawalSetting'
import TradingVolumeRanking from './pages/leaderboard/TradingVolumeRanking'
import DeviceManagement from './pages/users/DeviceManagement'
import Kyc from './pages/users/Kyc'
import KycDetail from './pages/users/KycDetail'
import UserAMALNetHolding from './pages/users/UserAMALNetHolding'
import UserEnableFeeSetting from './pages/users/UserEnableFeeSetting'
import UserGroupSetting from './pages/users/UserGroupSetting'
import Users from './pages/users/Users'
import UserSetting from './pages/users/UserSetting'

// ======================== Permssion Item =======================
import ChangePermission from './pages/permission/ChangePermission'

// ======================== Exchange Item ========================
import CircuitBreakerSetting from './pages/circuit_breaker/CircuitBreakerSetting'
import TradingFeeSetting from './pages/exchange/TradingFeeSetting'
import WithdrawFeeSetting from './pages/exchange/WithdrawFeeSetting'
import WithdrawSetting from './pages/exchange/WithdrawSetting'
import PriceSetting from './pages/sales_point/PriceSetting'
// import SiteSetting from './pages/site_settings/SiteSetting'
import BankSetting from './pages/exchange/BankSetting.vue'
// ========================== Orders Item ========================
import OpenOrder from './pages/orders/OpenOrder'
import OrderHistory from './pages/orders/OrderHistory'
import TradeHistory from './pages/orders/TradeHistory'

// ======================= Transaction Item ======================
import Deposit from './pages/transactions/Deposit'
import Withdraw from './pages/transactions/Withdraw'

// ======================== Marketing Item =======================
import ExchangeBalance from './pages/exchange/ExchangeBalance'
import EmailMarketingEdit from './pages/marketing/EmailMarketingEdit'
import EmailMarketingList from './pages/marketing/EmailMarketingList'
import EmailMarketingSend from './pages/marketing/EmailMarketingSend'
import NoticeEdit from './pages/marketing/NoticeEdit'
import NoticeList from './pages/marketing/NoticeList'

//=========================== Wallet ===============================
import AirdropHistory from './pages/airdrop/AirdropHistory'
import AirdropPaymentHistory from './pages/airdrop/AirdropPaymentHistory'
import AirdropSetting from './pages/airdrop/AirdropSetting'
import AutoDividendHistory from './pages/airdrop/AutoDividendHistory'
import AutoDividendSetting from './pages/airdrop/AutoDividendSetting'
import CashbackHistory from './pages/airdrop/CashbackHistory'
import ManualDividendHistory from './pages/airdrop/ManualDividendHistory'
import RegisterERC20 from './pages/register_erc20/RegisterERC20'
import ColdWalletSetting from './pages/wallet/ColdWalletSetting'

// ========================= Salespoint =========================
import BuyHistory from './pages/salespoint/BuyHistory'

// ============================Referral Item=====================
import DividendSettingManual from './pages/airdrop/DividendSettingManual'
import ReferralHistory from './pages/referral/ReferralHistory'
import ReferralSetting from './pages/referral/ReferralSetting'

// ========================== Margin Orders Item ========================
import FundingHistory from './pages/margin_orders/FundingHistory.vue'
import MarginOrder from './pages/margin_orders/Order'
import MarginPosition from './pages/margin_orders/Position'
import MarginTradeHistory from './pages/margin_orders/TradeHistory'
import MarginTradingSetting from './pages/margin_orders/TradingSetting'

// ============================Instruments=====================
import BitmexAccount from './pages/bitmex/BitmexAccount.vue'
import BitmexMappingInstrument from './pages/bitmex/BitmexMappingInstrument'
import MappingOrder from './pages/bitmex/MappingOrder'
import TracedAccount from './pages/bitmex/TracedAccount.vue'
import InstrumentResource from './pages/instruments/InstrumentResource'
import Instruments from './pages/instruments/Instruments.vue'
import InstrumentsFutures from './pages/instruments_futures/InstrumentsFuture.vue'
import EntryLeaderboardPaymentManual from './pages/margin_orders/EntryLeaderboardPaymentManual.vue'
import EntryManagement from './pages/margin_orders/EntryManagement'
import ManualEntryLeaderboardPaidHistory from './pages/margin_orders/ManualEntryLeaderboardPaidHistory'
import RiskManagement from './pages/margin_orders/RiskManagement'

// ============================Reward Center=====================
import CreateInstruments from "@/pages/instruments_futures/CreateInstruments.vue"
import CreateNewTier from "@/pages/instruments_futures/CreateNewTier.vue"
import UpdateInstruments from "@/pages/instruments_futures/UpdateInstruments.vue"
import OrderFuturesRecords from "./pages/futures_records/OrderFuturesRecords"
import PositionFuturesRecords from "./pages/futures_records/PositionFuturesRecords"
import TradeFuturesRecords from "./pages/futures_records/TradeFuturesRecords"
import RewardCenter from './pages/reward_center/RewardCenter.vue'
import RewardCenterResource from './pages/reward_center/RewardCenterResource.vue'


Vue.use(VueRouter)

const dividend = [
  {
    path: '/traced-account',
    name: 'TracedAccount',
    component: TracedAccount,
  },
  {
    path: '/mapping-order',
    name: 'MappingOrder',
    component: MappingOrder,
  },
  {
    path: '/bitmex-account',
    name: 'BitmexAccount',
    component: BitmexAccount,
  },
  {
    path: '/dividend-history',
    name: 'AirdropHistory',
    component: AirdropHistory,
  },
  {
    path: '/dividend-payment-history',
    name: 'AirdropPaymentHistory',
    component: AirdropPaymentHistory,
  },
  {
    path: '/cashback-history',
    name: 'CashbackHistory',
    component: CashbackHistory,
  },
  {
    path: '/dividend-setting',
    name: 'AirdropSetting',
    component: AirdropSetting,
  },
  {
    path: '/dividend-setting-manual',
    name: 'DividendSettingManual',
    component: DividendSettingManual,
  },
  {
    path: '/auto-dividend-setting',
    name: 'AutoDividendSetting',
    component: AutoDividendSetting,
  },
  // {
  //     "path": '/manual-dividend-setting',
  //     "name": 'ManualDividendSetting',
  //     "component": ManualDividendSetting
  // },
  {
    path: '/auto-dividend-history',
    name: 'AutoDividendHistory',
    component: AutoDividendHistory,
  },
  {
    path: '/manual-dividend-history',
    name: 'ManualDividendHistory',
    component: ManualDividendHistory,
  },
]

const routes = [
  {
    path: '/',
    redirect: { name: 'open_order' },
    alias: '/home',
  },
  // {
  //   path: '/deposit-usd',
  //   name: 'Deposit USD',
  //   component: DepositFiat,
  // },
  // {
  //   path: '/withdraw-usd',
  //   name: 'Withdraw USD',
  //   component: WithdrawFiat,
  // },
  {
    path: '/deposit',
    name: 'Deposit',
    component: Deposit,
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: Withdraw,
  },
  {
    path: '/profit',
    name: 'profit',
    component: CalculateProfit,
  },
  {
    path: '/kyc',
    name: 'kyc',
    component: Kyc,
  },
  {
    path: '/amal-net',
    name: 'amal_net',
    component: UserAMALNetHolding,
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
  },
  {
    path: '/kyc/detail',
    name: 'kyc-detail',
    component: KycDetail,
  },
  {
    path: '/orders/open-order',
    name: 'open_order',
    component: OpenOrder,
  },
  {
    path: '/orders/history',
    name: 'order_history',
    component: OrderHistory,
  },
  {
    path: '/notices',
    name: 'Notice',
    component: NoticeList,
  },
  {
    path: '/notice/edit',
    name: 'notice-edit',
    component: NoticeEdit,
  },
  {
    path: '/orders/trade-history',
    name: 'trade_history',
    component: TradeHistory,
  },
  {
    path: '/email-marketing',
    name: 'Emails Marketing',
    component: EmailMarketingList,
  },
  {
    path: '/email-marketing/edit',
    name: 'emailMarketingEdit',
    component: EmailMarketingEdit,
  },
  {
    path: '/email-marketing/create',
    name: 'emailMarketingCreate',
    component: EmailMarketingEdit,
  },
  {
    path: '/email-marketing/send',
    name: 'emailMarketingSend',
    component: EmailMarketingSend,
  },
  {
    path: '/user-setting',
    name: 'user_setting',
    component: UserSetting,
  },
  {
    path: '/user-enable-fee-setting',
    name: 'user_enable_fee_setting',
    component: UserEnableFeeSetting,
  },
  {
    path: '/enable-withdrawal-setting',
    name: 'enable_withdrawal_setting',
    component: EnableWithdrawalSetting,
  },
  {
    path: '/enable-trading-setting',
    name: 'enable_trading_setting',
    component: EnableTradingSetting,
  },
  {
    path: '/device-management',
    name: 'device_management',
    component: DeviceManagement,
  },
  {
    path: '/user-group-setting',
    name: 'user_group_setting',
    component: UserGroupSetting,
  },
  {
    path: '/transaction-setting',
    name: 'withdraw_setting',
    component: WithdrawSetting,
  },
  {
    path: '/trading-fee-setting',
    name: 'trading_fee_setting',
    component: TradingFeeSetting,
  },
  {
    path: '/withdraw-fee-setting',
    name: 'withdraw_fee_setting',
    component: WithdrawFeeSetting,
  },
  {
    path: '/circuit-breaker-setting',
    name: 'circuit_breaker_setting',
    component: CircuitBreakerSetting,
  },
  {
    path: '/bank-setting',
    name: 'bank_setting',
    component: BankSetting,
  },
  // {
  //   path: '/site-setting',
  //   name: 'site_setting',
  //   component: SiteSetting,
  // },
  {
    path: '/exchange-balance',
    name: 'exchange_balance',
    component: ExchangeBalance,
  },
  // {
  //     "path": '/exchange-balance-detail',
  //     "name": 'exchange_balance_detail',
  //     "component": ExchangeBalanceDetail,
  // },
  // {
  //   path: '/permissions',
  //   name: 'Permissions',
  //   component: Permissions,
  // },
  {
    path: '/permissions/edit',
    name: 'ChangePermission',
    component: ChangePermission,
  },
  {
    path: '/register-erc20',
    name: 'setting:register-erc20',
    component: RegisterERC20,
  },
  {
    path: '/sales-point',
    name: 'setting:sales-point',
    component: PriceSetting,
  },
  {
    path: '/salespoint/buy-history',
    name: 'buy_history',
    component: BuyHistory,
  },
  {
    path: '/cold-wallet-setting',
    name: 'ColdWalletSetting',
    component: ColdWalletSetting,
  },
  {
    path: '/referral-history',
    name: 'ReferralHistory',
    component: ReferralHistory,
  },
  {
    path: '/referral-setting',
    name: 'ReferralSetting',
    component: ReferralSetting,
  },
  {
    path: '/margin/order',
    name: 'OrderMargin',
    component: MarginOrder,
  },
  {
    path: '/margin/position',
    name: 'PositionsMargin',
    component: MarginPosition,
  },
  {
    path: '/margin/risk-management',
    name: 'RiskManagement',
    component: RiskManagement,
  },
  {
    path: '/margin/entry-management',
    name: 'EntryManagement',
    component: EntryManagement,
  },
  {
    path: '/margin/entry-payment-manual',
    name: 'EntryLeaderboardPaymentManual',
    component: EntryLeaderboardPaymentManual,
  },
  {
    path: '/margin/entry-payment-manual-paid',
    name: 'ManualEntryLeaderboardPaidHistory',
    component: ManualEntryLeaderboardPaidHistory,
  },
  {
    path: '/margin/trade-history',
    name: 'TradeHistoryMargin',
    component: MarginTradeHistory,
  },
  {
    path: '/margin/funding-history',
    name: 'FundingHistory',
    component: FundingHistory,
  },
  {
    path: '/margin/trade-setting',
    name: 'MarginTradingSetting',
    component: MarginTradingSetting,
  },
  {
    path: '/instruments',
    name: 'Instruments',
    component: Instruments,
  },
  {
    path: '/instruments-resource',
    name: 'InstrumentResource',
    component: InstrumentResource,
  },
  {
    path: '/instruments-futures',
    name: 'Instruments Futures',
    component: InstrumentsFutures,
  },
  {
    path: '/instruments-futures/create',
    name: 'Create Instruments Futures',
    component: CreateInstruments,
  },
  {
    path: '/instruments-futures/update',
    name: 'Update Instruments Futures',
    component: UpdateInstruments,
  },
  {
    path: '/instruments-futures/create',
    name: 'Create New Tier',
    component: CreateNewTier,
  },
  {
    path: '/trading-volume-ranking',
    name: 'tradingVolumeRanking',
    component: TradingVolumeRanking,
  },
  {
    path: '/mapping-instrument',
    name: 'BitmexMappingInstrument',
    component: BitmexMappingInstrument,
  },
  {
    path: '/reward-center',
    name: 'Reward Center',
    component: RewardCenter,
  },
  {
    path: '/reward-center-resource',
    name: 'Reward Center Resource',
    component: RewardCenterResource,
  },
  {
    path: '/order-future-record',
    name: 'OrderFuturesRecords',
    component: OrderFuturesRecords,
  },
  {
    path: '/position-future-record',
    name: 'PositionFuturesRecords',
    component: PositionFuturesRecords,
  },
  {
    path: '/trade-future-record',
    name: 'TradeFuturesRecords',
    component: TradeFuturesRecords,
  },
  ...dividend,
  { path: '*', name: 'Not Found', component: NotFound },
]

const router = new VueRouter({
  mode: 'history',
  base: '/admin',
  routes
})

export default router

